const IDLE_MS = 2 * 60 * 1000;
const CHECK_INTERVAL_MS = 15 * 1000;
const ACTIVITY_EVENTS = ["mousemove", "keydown", "touchstart", "scroll", "wheel", "click"];

// Tracks wall-clock time while the tab is visible AND the user has interacted
// recently, instead of a flat elapsed-time cap. Time simply stops accumulating
// while the tab is hidden or the user has gone idle (no input for IDLE_MS), so
// a backgrounded/walked-away-from session never inflates study-time stats —
// but a genuinely long, actively-worked session is also never truncated.
export function createActivityTimer() {
  let accumulatedMs = 0;
  let segmentStart = document.hidden ? null : Date.now();
  let lastActivityAt = Date.now();
  let idle = false;

  const pause = () => {
    if (segmentStart !== null) {
      accumulatedMs += Date.now() - segmentStart;
      segmentStart = null;
    }
  };
  const resume = () => {
    if (segmentStart === null && !document.hidden && !idle) segmentStart = Date.now();
  };
  const onActivity = () => {
    lastActivityAt = Date.now();
    if (idle) { idle = false; resume(); }
  };
  const onVisibility = () => {
    if (document.hidden) pause();
    else { lastActivityAt = Date.now(); resume(); }
  };
  const intervalId = setInterval(() => {
    if (!idle && segmentStart !== null && Date.now() - lastActivityAt > IDLE_MS) {
      idle = true;
      pause();
    }
  }, CHECK_INTERVAL_MS);

  ACTIVITY_EVENTS.forEach(ev => window.addEventListener(ev, onActivity, { passive: true }));
  document.addEventListener("visibilitychange", onVisibility);

  return {
    // Ceils to the next whole minute so a short-but-real session never reads as
    // 0, floored at 1 as a safety net (e.g. against clock-skew edge cases).
    getActiveMinutes: () => {
      const liveMs = accumulatedMs + (segmentStart !== null ? Date.now() - segmentStart : 0);
      return Math.max(Math.ceil(liveMs / 60000), 1);
    },
    stop: () => {
      clearInterval(intervalId);
      ACTIVITY_EVENTS.forEach(ev => window.removeEventListener(ev, onActivity));
      document.removeEventListener("visibilitychange", onVisibility);
    },
  };
}
